import React from 'react';
import classNames from 'classnames';
import useDarkMode from 'hooks/useDarkMode';
import Footer from 'layout/Footer/Footer';

const DefaultFooter = () => {
	const { darkModeStatus } = useDarkMode();

	return (
		<Footer>
			<div className='container-fluid'>
				<div className='row'>
					<div className='col'>
						<span className='fw-light'>Copyright © {new Date().getFullYear()}</span>
					</div>
					<div className='col-auto'>
						<a
							href='/'
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold'>WHITECRUST NG</small>
						</a>
					</div>
					<div className='col-auto'>
						Powered By
						<a
							href='//pintoptechnologies.com'
							target='_blank'
							rel='noreferrer'
							className={classNames('text-decoration-none', {
								'link-dark': !darkModeStatus,
								'link-light': darkModeStatus,
							})}>
							<small className='fw-bold ms-2'>PINTOP TECHNOLOGIES</small>
						</a>
					</div>
				</div>
			</div>
		</Footer>
	);
};

export default DefaultFooter;
